export default __webpack_public_path__ + "media/images/icon_local-ba9eb8c6b0d2649a5cdad6574f7d516c.png";